var infoCards = JSON.parse(document.querySelector('#info-cards-data').innerText).info_cards;
var currentInfoCardIndex = 0;
function createInfoCard(info) {
  var div = document.createElement('div');
  if (info.full_width) {
    div.className = 'info-card full-width';
    div.innerHTML = "\n      <div class=\"info-card__media\">\n      <a href=\"".concat(info.cta_link, "\">\n        <img\n        class=\"info-card__media-image\"\n        src=\"").concat(info.image, "\"\n        alt=\"").concat(info.title, "\"\n        >\n      </a>\n      </div>\n      <div class=\"info-card__content\" style=\"background-color:").concat(info.background_color, "\">\n        <a\n        class=\"info-card__content-cta\"\n        style=\"color: ").concat(info.text_color, "; font-size:").concat(info.font_size, "\" href=\"").concat(info.cta_link, "\">\n          ").concat(info.cta_label, "\n        </a>\n        <a href=\"").concat(info.cta_link, "\">\n        <h2 class=\"info-card__content-title\" style=\"color:").concat(info.text_color, "\">").concat(info.title, "</h2>\n        </a>\n      </div>\n    ");
  } else {
    div.className = 'info-card no-full-width';
    div.innerHTML = "\n      <div class=\"info-card__media\">\n      <a href=\"".concat(info.cta_link, "\">\n        <img\n          class=\"info-card__media-image\"\n          src=\"").concat(info.image, "\"\n          alt=\"").concat(info.title, "\"\n          >\n      </a>\n      </div>\n      <div class=\"info-card__content\">\n      <a href=\"").concat(info.cta_link, "\">\n        <h2 class=\"info-card__content-title\">").concat(info.title, "</h2>\n      </a>\n        <a class=\"info-card__content-cta\" style=\"font-size:").concat(info.font_size, "\" href=\"").concat(info.cta_link, "\">\n          ").concat(info.cta_label, "\n        </a>\n      </div>\n    ");
  }
  return div;
}
export function insertInfoCards() {
  console.log('insertInfo');
  var items = document.querySelectorAll('.item-product, .info-card');
  while (currentInfoCardIndex < infoCards.length) {
    var info = infoCards[currentInfoCardIndex];
    var position = parseInt(info.position, 10);
    if (position >= items.length) {
      break;
    }
    var target = items[position - 1];
    if (!target.classList.contains('info-card')) {
      var infoCard = createInfoCard(info);
      target.parentNode.insertBefore(infoCard, target);
    }
    currentInfoCardIndex++;
  }
}
window.infoCardsInit = insertInfoCards();